<template>
  <transition-group
    name="card-anim"
    class="cards"
    mode="out-in"
    tag="div"
    appear
    @before-enter="beforeEnter"
  >
    <template v-for="(item, index) in cards">
      <Card
        v-if="!item.isPromoCard"
        :ref="getCardRef(item.id)"
        class="card-anim__el"
        :class="{ 'card--summary-is-hidden': summaryIsHidden }"
        :backgroundColor="backgroundColor"
        :card="item"
        :context="context"
        :genderToShow="genderToShow"
        :key="item.id"
        :imageFormat="imageFormat"
        :isQuickViewEnabled="isQuickViewEnabled"
        :index="item.cardIndex"
        :summaryIsHidden="summaryIsHidden"
        :data-index="index"
        @mousemove.native="removeBodyTransitionClass"
        @mouseleave.native="removeBodyTransitionClass"
      />
      <PromoCard
        v-else
        :key="item.id"
        class="card-anim__el"
        :context="context"
        :index="item.cardIndex"
        :promoCard="item"
        :onCardView="onPromoCardView"
        :onCardClick="onPromoCardClick"
        :data-index="index"
      />
    </template>
  </transition-group>
</template>

<script>
import { CONTENTFUL_IMAGE_FORMAT } from '@/components/_shared/ImageContentful.vue'
import PromoCard from './PromoCard.vue'
import Card, { CARD_COLORS } from './Card/Card.vue'
import settings from './card-settings'

export const CARDS_TRANSITION_TIME = 300 // same as CSS

export default {
  name: 'Cards',
  components: { Card, PromoCard },
  props: {
    backgroundColor: {
      type: String,
      default: CARD_COLORS.light,
    },

    genderToShow: {
      type: String,
    },

    cards: {
      type: Array,
      required: true,
    },

    context: {
      type: String,
    },

    isScrollDetectionEnabled: {
      type: Boolean,
      default: false,
    },

    isQuickViewEnabled: {
      type: Boolean,
      default: true,
    },

    summaryIsHidden: {
      type: Boolean,
      required: false,
      default: false,
    },

    imageFormat: {
      type: String,
      default: CONTENTFUL_IMAGE_FORMAT.default,
      validator(value) {
        return Object.values(CONTENTFUL_IMAGE_FORMAT).includes(value)
      },
    },

    onPromoCardView: {
      type: Function,
    },

    onPromoCardClick: {
      type: Function,
      default() {
        return () => {}
      },
    },
  },

  data() {
    return {
      cardWidth: 0,
      isHoverStateEnabled: true,
    }
  },

  methods: {
    getCardElementByProductUrl(url) {
      const card = this.cards.find(card => {
        return card.variants?.some(variant => variant.productUrl.indexOf(url) >= 0)
      })
      if (card) return this.getCardElementById(card.id)
    },

    getCardElementById(cardId) {
      const component = this.$refs[this.getCardRef(cardId)]
      return (component[0] || {}).$el
    },

    getCardRef(cardId) {
      return `card-${cardId}`
    },

    removeBodyTransitionClass() {
      document.body.classList.remove(settings.transitionClass)
    },

    beforeEnter(el) {
      if (Number(el.dataset.index) === this.cards.length - 1) this.$emit('before-last-enter')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './card-settings';

.cards {
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: center;
  width: 100%;

  &:after {
    content: '';
    flex: 1;
  }
}

.card-anim {
  &-enter-active,
  &-leave-active {
    transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }

  &-enter,
  &-leave-to {
    transform: translate3d(0, 30px, 0);
    opacity: 0;
  }

  &__el {
    @for $i from 1 through 16 {
      &:nth-child(16n + #{$i}) {
        transition-delay: #{$i * 50}ms;
      }
    }
  }
}
</style>
